// Module
var code = "<template class=\"${ctaPage ? 'cta-page ' : ''}${busy ? '--busy' : ''}\"> <require from=\"./page.scss\"></require> <busy-indicator if.bind=\"busy\"></busy-indicator> <div class=\"content-wrapper\"> <slot></slot> </div> </template> ";
// Exports
module.exports = code;